// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".polymer-modal-close-button {\n  cursor: pointer;\n}", "",{"version":3,"sources":["webpack://./src/components/P2Modal/closebutton.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ","sourcesContent":[".polymer-modal-close-button {\n    cursor: pointer;\n  }  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
